module.exports = __webpack_public_path__ + "static/media/interior2.bb762e28.svg";